import AOS from "aos";
import Rellax from "rellax";
import Splitting from "splitting";

export default () => ({
   viewportHeight: null,
   viewportHeightMinusHeader: null,
   /* store array of element IDs in the wishlist, this will be populated once dynamic/enquiriesPanel is injected */
   wishlistItemElementIds: [],
   init() {

      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) == false){

         Splitting();

         if (document.querySelector('.js-rellax')) {
            var rellax = new Rellax('.js-rellax');
         }

      }

      AOS.init({
         mirror: false,
         once: true,
         disable: 'mobile'
      });

      this.viewportHeight = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${this.viewportHeight}px`);

      let windowHeightMinusHeader = parseInt(window.innerHeight - (document.getElementById('site-header-all').offsetHeight));
      this.viewportHeightMinusHeader = windowHeightMinusHeader * 0.01;
      document.documentElement.style.setProperty('--vhmh', `${this.viewportHeightMinusHeader}px`);

   }
})
